import React, { useState } from 'react';

const Mascot = ({ id, level = 1, size = 120, previewAccessory = null, interactive = true }) => {
  const [isFlexing, setIsFlexing] = useState(false);
  const [mood, setMood] = useState('happy');

  // Evolution logic
  let stage = 1;
  if (level >= 10 && level < 30) stage = 2;
  if (level >= 30) stage = 3;

  const scale = stage === 1 ? 0.6 : (stage === 2 ? 0.8 : 1);

  // Animation on click
  const handleClick = () => {
    if (isFlexing || mascotType === 'none' || !interactive) return;
    setIsFlexing(true);
    setMood('pumped');
    setTimeout(() => {
      setIsFlexing(false);
      setMood('happy');
    }, 1500);
  };

  const mascotType = id.replace('mascot_', '');

  // Dynamic layout for standardizing eyes and accessories position
  const getLayout = () => {
    switch (mascotType) {
      case 'fox':
      case 'shiba':
      case 'dog':
        return {
          eyeY: 85, eyeR: 7, eyeColor: '#2f3640', pupilR: 2, pupilColor: '#fff',
          headY: 10, crownY: 5, crownScale: 0.85, bandY: 42, bandScale: 0.85, neckY: 138, neckScale: 0.65,
          dbX: 55, dbY: 160
        };
      case 'fitbot':
      case 'robot':
        return {
          eyeY: 85, eyeR: 8, eyeColor: '#00f2fe', pupilR: 0, pupilColor: 'transparent',
          headY: -10, crownY: 5, crownScale: 1, bandY: 40, bandScale: 1, neckY: 118, neckScale: 1.1,
          dbX: 20, dbY: 140
        };
      case 'cat':
        return {
          eyeY: 85, eyeR: 8, eyeColor: 'transparent', pupilR: 0, pupilColor: 'transparent',
          headY: 15, crownY: 0, crownScale: 1, bandY: 42, bandScale: 1.15, neckY: 135, neckScale: 1.2,
          dbX: 30, dbY: 140
        };
      case 'kettlebell':
        return {
          eyeY: 100, eyeR: 8, eyeColor: '#fff', pupilR: 4, pupilColor: '#1a1a2e',
          headY: 15, crownY: 30, crownScale: 1, bandY: 65, bandScale: 0.75, neckY: 130, neckScale: 1.3,
          dbX: 30, dbY: 140
        };
      case 'blob':
      default:
        return {
          eyeY: 100, eyeR: 8, eyeColor: '#fff', pupilR: 4, pupilColor: '#1a1a2e',
          headY: 15, crownY: 20, crownScale: 1, bandY: 60, bandScale: 0.85, neckY: 125, neckScale: 1.1, neckWidth: 110, neckCurve: 30,
          dbX: 30, dbY: 140
        };
    }
  };
  const l = getLayout();

  const renderAccessory = () => {
    if (!previewAccessory) return null;
    
    switch (previewAccessory) {
      case 'accessory_glasses':
        return (
          <g style={{ transform: `translateY(${l.eyeY - 5}px)` }}>
            {/* Lunettes de soleil Thug Life */}
            <rect x="55" y="0" width="40" height="15" fill="#111" />
            <rect x="105" y="0" width="40" height="15" fill="#111" />
            <rect x="95" y="5" width="10" height="5" fill="#111" />
            {/* Reflets */}
            <polygon points="65,15 80,0 90,0 75,15" fill="white" opacity="0.3" />
            <polygon points="115,15 130,0 140,0 125,15" fill="white" opacity="0.3" />
          </g>
        );
      case 'accessory_headband':
        return (
          <g style={{ transform: `translateY(${l.bandY}px) scale(${l.bandScale || 1})`, transformOrigin: '100px 15px' }}>
            {/* Bandeau de Ninja */}
            <path d="M 50 10 Q 100 0 150 10 L 145 25 Q 100 15 55 25 Z" fill="#E74C3C" />
            <path d="M 150 15 L 170 30 M 150 15 L 165 5" stroke="#E74C3C" strokeWidth="6" strokeLinecap="round" />
            <rect x="90" y="5" width="20" height="15" fill="#BDC3C7" />
          </g>
        );
      case 'accessory_crown':
        return (
          <g style={{ transform: `translateY(${l.crownY}px) scale(${l.crownScale || 1})`, transformOrigin: '100px 50px' }}>
            {/* Couronne */}
            <path d="M 70 50 L 60 20 L 80 35 L 100 10 L 120 35 L 140 20 L 130 50 Z" fill="#F1C40F" />
            <circle cx="60" cy="20" r="4" fill="#E74C3C" />
            <circle cx="100" cy="10" r="4" fill="#E74C3C" />
            <circle cx="140" cy="20" r="4" fill="#E74C3C" />
          </g>
        );
      case 'accessory_necklace':
        return (
          <g style={{ transform: `translateY(${l.neckY}px) scale(${l.neckScale || 1})`, transformOrigin: '100px 0px' }}>
            {/* Collier */}
            <path d={`M ${100 - (l.neckWidth || 70)/2} 0 Q 100 ${l.neckCurve || 25} ${100 + (l.neckWidth || 70)/2} 0`} stroke="#f1c40f" strokeWidth="6" strokeLinecap="round" fill="none" />
            <circle cx="100" cy="13" r="7" fill="#e74c3c" stroke="#f39c12" strokeWidth="2" />
            <polygon points="100,20 104,28 96,28" fill="#f1c40f" />
          </g>
        );
      default:
        return null;
    }
  };

  const renderDumbbell = (x, y) => {
    if (!isFlexing) return null;
    return (
      <g style={{ transform: `translate(${x}px, ${y}px)` }}>
        <line x1="-15" y1="0" x2="15" y2="0" stroke="#7f8c8d" strokeWidth="6" />
        <rect x="-20" y="-15" width="10" height="30" rx="2" fill="#2c3e50" />
        <rect x="-25" y="-10" width="5" height="20" rx="1" fill="#34495e" />
        <rect x="10" y="-15" width="10" height="30" rx="2" fill="#2c3e50" />
        <rect x="20" y="-10" width="5" height="20" rx="1" fill="#34495e" />
      </g>
    );
  };

  return (
    <div
      style={{
        display: 'inline-block',
        cursor: interactive && mascotType !== 'none' ? 'pointer' : 'default',
        width: `${size * scale}px`,
        height: `${size * scale}px`,
        position: 'relative'
      }}
      onClick={handleClick}
      title={mascotType !== 'none' ? `Niveau ${level} (Stade ${stage})` : ''}
    >
      <style>{`
        .mascot-svg {
          width: 100%;
          height: 100%;
          transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          overflow: visible;
        }
        .interactive-mascot:hover {
          transform: scale(1.05) translateY(-5px);
          filter: drop-shadow(0 10px 15px rgba(0,0,0,0.3));
        }
        
        .static-mascot .mascot-anim-group,
        .static-mascot .mascot-shadow,
        .static-mascot .mascot-eyes,
        .static-mascot .mascot-sweat,
        .static-mascot .mascot-body-group {
          animation: none !important;
          transform: none !important;
        }
        
        .mascot-anim-group, .mascot-shadow, .mascot-eyes, .mascot-sweat, .mascot-body-group, .mascot-arm-left, .mascot-arm-right, .mascot-dumbbell {
          will-change: transform;
        }
        
        .mascot-anim-group {
          transform-origin: center;
          transform-box: fill-box;
        }

        /* Idle Floating */
        @keyframes float {
          0% { transform: translate(0, 0); }
          50% { transform: translate(0, -10px); }
          100% { transform: translate(0, 0); }
        }
        @keyframes shadow-shrink {
          0% { transform: scale(1); opacity: 0.2; }
          50% { transform: scale(0.8); opacity: 0.1; }
          100% { transform: scale(1); opacity: 0.2; }
        }
        .mascot-body-group {
          animation: float 3s ease-in-out infinite;
          transform-origin: center;
          transform-box: fill-box;
        }
        .mascot-shadow {
          animation: shadow-shrink 3s ease-in-out infinite;
          transform-origin: center;
          transform-box: fill-box;
        }

        /* Flexing Animations */
        @keyframes flex-body {
          0% { transform: scale(1) translate(0, 0); animation-timing-function: ease-out; }
          20% { transform: scale(1.1, 0.9) translate(0, 10px); animation-timing-function: ease-in-out; }
          50% { transform: scale(0.95, 1.05) translate(0, -20px); animation-timing-function: ease-in-out; }
          80% { transform: scale(1.05, 0.95) translate(0, 5px); animation-timing-function: ease-in-out; }
          100% { transform: scale(1) translate(0, 0); }
        }
        @keyframes flex-arm-rotate-left {
          0% { transform: rotate(0deg) translate(0, 0); }
          50% { transform: rotate(120deg) translate(0, -5px); }
          100% { transform: rotate(0deg) translate(0, 0); }
        }
        @keyframes flex-arm-rotate-right {
          0% { transform: rotate(0deg) translate(0, 0); }
          50% { transform: rotate(-120deg) translate(0, -5px); }
          100% { transform: rotate(0deg) translate(0, 0); }
        }
        @keyframes flex-dumbbell {
          0% { transform: rotate(0deg) translate(0, 0); }
          50% { transform: rotate(-30deg) translate(0, -20px); }
          100% { transform: rotate(0deg) translate(0, 0); }
        }

        .flexing .mascot-anim-group {
          animation: flex-body 1.5s ease-in-out;
        }
        .flexing .mascot-arm-left {
          animation: flex-arm-rotate-left 1.5s ease-in-out;
        }
        .flexing .mascot-arm-right {
          animation: flex-arm-rotate-right 1.5s ease-in-out;
        }
        .flexing .mascot-dumbbell {
          animation: flex-dumbbell 1.5s ease-in-out;
        }

        /* Blinking & Sweat */
        @keyframes blink {
          0%, 96%, 98% { transform: scaleY(1); }
          97% { transform: scaleY(0.1); }
          100% { transform: scaleY(1); }
        }
        .mascot-eyes {
          animation: blink 4s infinite;
          transform-origin: center;
          transform-box: fill-box;
        }
        @keyframes sweat-drip {
          0% { transform: translate(0, 0); opacity: 1; }
          100% { transform: translate(0, 20px); opacity: 0; }
        }
        .mascot-sweat {
          animation: sweat-drip 1.5s ease-out forwards;
        }
      `}</style>
      
      <svg className={`mascot-svg ${isFlexing ? 'flexing' : ''} ${!interactive || mascotType === 'none' ? 'static-mascot' : 'interactive-mascot'}`} viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="happyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#4facfe" />
            <stop offset="100%" stopColor="#00f2fe" />
          </linearGradient>
          <linearGradient id="pumpedGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ff0844" />
            <stop offset="100%" stopColor="#ffb199" />
          </linearGradient>
          <linearGradient id="dogHappyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#e67e22" />
            <stop offset="100%" stopColor="#d35400" />
          </linearGradient>
          <linearGradient id="dogPumpedGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#c0392b" />
            <stop offset="100%" stopColor="#e74c3c" />
          </linearGradient>
          <linearGradient id="pandaHappyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#d35400" />
            <stop offset="100%" stopColor="#c0392b" />
          </linearGradient>
          <linearGradient id="pandaPumpedGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#c0392b" />
            <stop offset="100%" stopColor="#922b21" />
          </linearGradient>
          <filter id="neonGlow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="8" result="blur" />
            <feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge>
          </filter>
          <linearGradient id="glassGrad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="rgba(255,255,255,0.4)" />
            <stop offset="100%" stopColor="rgba(255,255,255,0.1)" />
          </linearGradient>
        </defs>

        <g style={{ transform: 'none', transformOrigin: 'center bottom' }}>
          {/* Shadow */}
          <ellipse cx="100" cy="185" rx="50" ry="12" fill="rgba(0,0,0,0.3)" className="mascot-shadow" />

          {/* ANIMATED GROUP (moves everything together when flexing) */}
          <g className="mascot-anim-group" filter={mood === 'pumped' ? 'url(#neonGlow)' : 'none'}>

            {/* --- BLOB --- */}
            {mascotType === 'blob' && (
              <g className="mascot-blob">
                <path d="
                  M 100 55
                  C 124 55, 140 79, 156 111
                  C 172 143, 156 159, 132 155
                  C 112 152, 88 152, 68 155
                  C 44 159, 28 143, 44 111
                  C 60 79, 76 55, 100 55 Z
                " 
                      fill={mood === 'pumped' ? 'url(#pumpedGrad)' : 'url(#happyGrad)'} 
                      className="mascot-body" />
                
                {/* Lighting Effects */}
                <path d="M 65 85 C 75 65, 90 60, 105 60" stroke="#fff" strokeWidth="7" strokeLinecap="round" fill="none" opacity="0.4" />
                <circle cx="120" cy="65" r="3.5" fill="#fff" opacity="0.3" />
                
                <g className="mascot-arm-left" style={{ transformOrigin: '50px 110px' }}>
                  <path d="M 50 110 Q 20 120, 25 140" stroke={mood === 'pumped' ? 'url(#pumpedGrad)' : 'url(#happyGrad)'} strokeWidth="12" strokeLinecap="round" fill="none" />
                  {renderDumbbell(25, 140)}
                </g>
                <g className="mascot-arm-right" style={{ transformOrigin: '150px 110px' }}>
                  <path d="M 150 110 Q 180 120, 175 140" stroke={mood === 'pumped' ? 'url(#pumpedGrad)' : 'url(#happyGrad)'} strokeWidth="12" strokeLinecap="round" fill="none" />
                  {renderDumbbell(175, 140)}
                </g>
              </g>
            )}

          {/* --- FOX --- */}
          {(mascotType === 'fox' || mascotType === 'shiba' || mascotType === 'dog') && (
            <g className="mascot-fox">
              {/* Fox Tail with White Tip (Centered and sweeping) */}
              <g className="fox-tail">
                <defs>
                  <clipPath id="foxTailClip">
                    <path d="M 100 160 C 160 200, 220 130, 180 75 C 150 105, 140 130, 100 160 Z" />
                  </clipPath>
                </defs>
                <path d="M 100 160 C 160 200, 220 130, 180 75 C 150 105, 140 130, 100 160 Z" fill={mood === 'pumped' ? 'url(#dogPumpedGrad)' : 'url(#dogHappyGrad)'} />
                <g clipPath="url(#foxTailClip)">
                  <polygon points="130,70 150,100 165,105 160,115 180,120 220,120 220,50 130,50" fill="#fff" />
                </g>
              </g>

              {/* Body */}
              <path d="M 85 130 C 65 140, 65 180, 80 190 Q 100 195, 120 190 C 135 180, 135 140, 115 130 Z" fill={mood === 'pumped' ? 'url(#dogPumpedGrad)' : 'url(#dogHappyGrad)'} className="mascot-body" />
              <path d="M 95 130 C 80 140, 80 175, 90 183 Q 100 188, 110 183 C 120 175, 120 140, 105 130 Z" fill="#fff" />

              {/* Back Legs (Short, Dark Socks tucked under the body, same thickness as arms) */}
              <path d="M 85 182 L 80 193" stroke="#332211" strokeWidth="14" strokeLinecap="round" />
              <path d="M 115 182 L 120 193" stroke="#332211" strokeWidth="14" strokeLinecap="round" />

              {/* Front Legs (Arms attached well inside the body so linecaps are completely hidden) */}
              <g className="mascot-arm-left" style={{ transformOrigin: '78px 145px' }}>
                <path d="M 78 145 L 68 175" stroke={mood === 'pumped' ? 'url(#dogPumpedGrad)' : 'url(#dogHappyGrad)'} strokeWidth="14" strokeLinecap="round" fill="none" />
                <path d="M 73 160 L 68 175" stroke="#332211" strokeWidth="14" strokeLinecap="round" fill="none" />
                {renderDumbbell(68, 175)}
              </g>
              <g className="mascot-arm-right" style={{ transformOrigin: '122px 145px' }}>
                <path d="M 122 145 L 132 175" stroke={mood === 'pumped' ? 'url(#dogPumpedGrad)' : 'url(#dogHappyGrad)'} strokeWidth="14" strokeLinecap="round" fill="none" />
                <path d="M 127 160 L 132 175" stroke="#332211" strokeWidth="14" strokeLinecap="round" fill="none" />
                {renderDumbbell(132, 175)}
              </g>

              {/* Head */}
              <g className="mascot-head">
                {/* Fox Ears (Thicker, black tips) */}
                <path d="M 60 75 L 45 10 L 90 45 Z" fill={mood === 'pumped' ? 'url(#dogPumpedGrad)' : 'url(#dogHappyGrad)'} />
                <path d="M 52 35 L 45 10 L 60 25 Z" fill="#332211" />
                <path d="M 65 65 L 52 25 L 85 45 Z" fill="#ffb8b8" />
                
                <path d="M 140 75 L 155 10 L 110 45 Z" fill={mood === 'pumped' ? 'url(#dogPumpedGrad)' : 'url(#dogHappyGrad)'} />
                <path d="M 148 35 L 155 10 L 140 25 Z" fill="#332211" />
                <path d="M 135 65 L 148 25 L 115 45 Z" fill="#ffb8b8" />

                {/* Head Base (Sharper, more diamond-shaped) */}
                <path d="
                  M 80 50
                  Q 100 40, 120 50
                  Q 145 60, 150 100
                  Q 145 125, 100 135
                  Q 55 125, 50 100
                  Q 55 60, 80 50 Z
                " fill={mood === 'pumped' ? 'url(#dogPumpedGrad)' : 'url(#dogHappyGrad)'} />
                
                {/* Fox Cheek Fluffs (M-shape Urajiro) */}
                <path d="
                  M 50 100 
                  C 70 100, 85 110, 100 110 
                  C 115 110, 130 100, 150 100 
                  Q 145 125, 100 135 
                  Q 55 125, 50 100 Z
                " fill="#fff" />

                {/* Blush */}
                <ellipse cx="65" cy="95" rx="6" ry="4" fill="#ff9999" opacity="0.9" />
                <ellipse cx="135" cy="95" rx="6" ry="4" fill="#ff9999" opacity="0.9" />

                {/* Eyes */}
                {mood === 'happy' ? (
                  <>
                    <circle cx="80" cy="85" r="9" fill="#2d3436" />
                    <circle cx="77" cy="81" r="3.5" fill="#fff" />
                    <circle cx="83" cy="88" r="1.5" fill="#fff" />
                    
                    <circle cx="120" cy="85" r="9" fill="#2d3436" />
                    <circle cx="117" cy="81" r="3.5" fill="#fff" />
                    <circle cx="123" cy="88" r="1.5" fill="#fff" />
                  </>
                ) : (
                  <>
                    <path d="M 77 79 L 89 85 L 77 91" stroke="#2d3436" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                    <path d="M 123 79 L 111 85 L 123 91" stroke="#2d3436" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                  </>
                )}

                {/* Eyebrows */}
                <path d="M 75 75 Q 80 72, 85 75" stroke="#2d3436" strokeWidth="2.5" strokeLinecap="round" fill="none" />
                <path d="M 125 75 Q 120 72, 115 75" stroke="#2d3436" strokeWidth="2.5" strokeLinecap="round" fill="none" />

                {/* Nose & Mouth */}
                <ellipse cx="100" cy="110" rx="5" ry="3.5" fill="#2d3436" />
                <path d="M 94 118 Q 97 122, 100 118 Q 103 122, 106 118" stroke="#2d3436" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
              </g>
            </g>
          )}

          {/* --- CAT (Tabby Kitten) --- */}
          {mascotType === 'cat' && (
            <g className="mascot-cat">
              {/* Tail */}
              <path d="M 135 150 Q 170 150, 175 120 Q 180 90, 160 85" stroke="#965d31" strokeWidth="20" strokeLinecap="round" fill="none" />
              <path d="M 135 150 Q 170 150, 175 120 Q 180 90, 160 85" stroke="#362113" strokeWidth="20" strokeLinecap="butt" strokeDasharray="8 16" fill="none" />
              <circle cx="160" cy="85" r="10" fill="#362113" />

              {/* Body (Bigger) */}
              <defs>
                <clipPath id="catBodyClip">
                  <path d="M 65 130 C 50 170, 48 190, 100 190 C 152 190, 150 170, 135 130 Z" />
                </clipPath>
              </defs>
              <path d="M 65 130 C 50 170, 48 190, 100 190 C 152 190, 150 170, 135 130 Z" fill="#965d31" />
              
              {/* Body Stripes (Clipped to body) */}
              <g clipPath="url(#catBodyClip)">
                <path d="M 20 125 L 85 140 L 20 150 Z" fill="#362113" stroke="#362113" strokeWidth="4" strokeLinejoin="round" />
                <path d="M 20 152 L 82 162 L 20 172 Z" fill="#362113" stroke="#362113" strokeWidth="4" strokeLinejoin="round" />
                <path d="M 20 175 L 80 182 L 20 190 Z" fill="#362113" stroke="#362113" strokeWidth="4" strokeLinejoin="round" />
                
                <path d="M 180 125 L 115 140 L 180 150 Z" fill="#362113" stroke="#362113" strokeWidth="4" strokeLinejoin="round" />
                <path d="M 180 152 L 118 162 L 180 172 Z" fill="#362113" stroke="#362113" strokeWidth="4" strokeLinejoin="round" />
                <path d="M 180 175 L 120 182 L 180 190 Z" fill="#362113" stroke="#362113" strokeWidth="4" strokeLinejoin="round" />
              </g>

              {/* Belly fluff */}
              <path d="M 85 130 Q 100 180 115 130 Z" fill="#f0ce99" />
              
              {/* Back Legs */}
              <ellipse cx="55" cy="180" rx="14" ry="10" fill="#965d31" />
              <ellipse cx="55" cy="182" rx="12" ry="8" fill="#f0ce99" />
              <ellipse cx="145" cy="180" rx="14" ry="10" fill="#965d31" />
              <ellipse cx="145" cy="182" rx="12" ry="8" fill="#f0ce99" />

              {/* Arms */}
              <g className="mascot-arm-left" style={{ transformOrigin: '65px 140px' }}>
                <path d="M 65 140 L 45 170" stroke="#965d31" strokeWidth="14" strokeLinecap="round" />
                <path d="M 65 140 L 45 170" stroke="#362113" strokeWidth="14" strokeDasharray="5 10" strokeDashoffset="-5" strokeLinecap="butt" />
                <ellipse cx="43" cy="172" rx="12" ry="10" fill="#f0ce99" />
                {renderDumbbell(45, 170)}
              </g>
              <g className="mascot-arm-right" style={{ transformOrigin: '135px 140px' }}>
                <path d="M 135 140 L 155 170" stroke="#965d31" strokeWidth="14" strokeLinecap="round" />
                <path d="M 135 140 L 155 170" stroke="#362113" strokeWidth="14" strokeDasharray="5 10" strokeDashoffset="-5" strokeLinecap="butt" />
                <ellipse cx="157" cy="172" rx="12" ry="10" fill="#f0ce99" />
                {renderDumbbell(155, 170)}
              </g>

              {/* Head */}
              <g className="mascot-head">
                <defs>
                  <clipPath id="catHeadClip">
                    <path d="
                      M 100 35 
                      C 130 35, 155 45, 165 65
                      L 175 80 L 165 90 L 175 100 L 160 110
                      C 145 135, 120 140, 100 140
                      C 80 140, 55 135, 40 110
                      L 25 100 L 35 90 L 25 80
                      L 35 65
                      C 45 45, 70 35, 100 35 Z
                    " />
                  </clipPath>
                </defs>
                {/* Ears (Wider) */}
                <path d="M 25 80 L 15 15 L 75 35 Z" fill="#362113" stroke="#362113" strokeWidth="4" strokeLinejoin="round" />
                <path d="M 30 75 L 22 25 L 65 40 Z" fill="#965d31" />
                <path d="M 35 70 L 28 35 L 55 45 Z" fill="#e38686" />
                
                <path d="M 175 80 L 185 15 L 125 35 Z" fill="#362113" stroke="#362113" strokeWidth="4" strokeLinejoin="round" />
                <path d="M 170 75 L 178 25 L 135 40 Z" fill="#965d31" />
                <path d="M 165 70 L 172 35 L 145 45 Z" fill="#e38686" />

                {/* Main Head (Fluffy cheeks) */}
                <path d="
                  M 100 35 
                  C 130 35, 155 45, 165 65
                  L 175 80 L 165 90 L 175 100 L 160 110
                  C 145 135, 120 140, 100 140
                  C 80 140, 55 135, 40 110
                  L 25 100 L 35 90 L 25 80
                  L 35 65
                  C 45 45, 70 35, 100 35 Z
                " fill="#965d31" />
                
                {/* Lower face fluff */}
                <path d="
                  M 35 100
                  Q 100 80, 165 100
                  L 160 110
                  C 145 135, 120 140, 100 140
                  C 80 140, 55 135, 40 110 Z
                " fill="#f0ce99" />

                {/* Head Stripes (Clipped to head) */}
                <g clipPath="url(#catHeadClip)">
                  {/* Forehead Stripes */}
                  <path d="M 92 20 L 100 65 L 108 20 Z" fill="#362113" />
                  <path d="M 68 25 L 82 62 L 86 25 Z" fill="#362113" />
                  <path d="M 132 25 L 118 62 L 114 25 Z" fill="#362113" />

                  {/* Cheek Stripes */}
                  <path d="M 20 72 L 55 80 L 20 82 Z" fill="#362113" />
                  <path d="M 20 88 L 50 92 L 20 95 Z" fill="#362113" />
                  <path d="M 180 72 L 145 80 L 180 82 Z" fill="#362113" />
                  <path d="M 180 88 L 150 92 L 180 95 Z" fill="#362113" />
                </g>

                {/* Blush */}
                <ellipse cx="65" cy="100" rx="10" ry="6" fill="#ff7675" opacity="0.6" />
                <ellipse cx="135" cy="100" rx="10" ry="6" fill="#ff7675" opacity="0.6" />

                {/* Eyes */}
                {mood === 'happy' ? (
                  <>
                    <ellipse cx="75" cy="85" rx="16" ry="18" fill="#362113" />
                    <ellipse cx="125" cy="85" rx="16" ry="18" fill="#362113" />
                    {/* Eye Highlights */}
                    <circle cx="70" cy="78" r="5" fill="#fff" />
                    <circle cx="82" cy="88" r="2" fill="#fff" />
                    <circle cx="120" cy="78" r="5" fill="#fff" />
                    <circle cx="132" cy="88" r="2" fill="#fff" />
                  </>
                ) : (
                  <>
                    {/* > < Manga eyes for effort */}
                    <path d="M 70 73 L 90 85 L 70 97" stroke="#362113" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                    <path d="M 130 73 L 110 85 L 130 97" stroke="#362113" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                  </>
                )}

                {/* Nose */}
                <path d="M 96 102 L 104 102 L 100 106 Z" fill="#e89b9b" stroke="#362113" strokeWidth="1.5" strokeLinejoin="round" />
                
                {/* Mouth */}
                {mood === 'pumped' ? (
                  <path d="M 100 106 L 100 110 Q 100 120 108 112 M 100 110 Q 100 120 92 112" stroke="#362113" strokeWidth="2" strokeLinecap="round" fill="none" />
                ) : (
                  <path d="M 100 106 L 100 112 Q 105 116 110 112 M 100 112 Q 95 116 90 112" stroke="#362113" strokeWidth="2.5" strokeLinecap="round" fill="none" />
                )}

                {/* Freckles */}
                <circle cx="85" cy="108" r="1" fill="#362113" opacity="0.5" />
                <circle cx="80" cy="112" r="1" fill="#362113" opacity="0.5" />
                <circle cx="115" cy="108" r="1" fill="#362113" opacity="0.5" />
                <circle cx="120" cy="112" r="1" fill="#362113" opacity="0.5" />

                {/* Whiskers */}
                <line x1="60" y1="105" x2="35" y2="108" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                <line x1="60" y1="110" x2="35" y2="115" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                <line x1="140" y1="105" x2="165" y2="108" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                <line x1="140" y1="110" x2="165" y2="115" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
              </g>
            </g>
          )}

          {/* --- FITBOT --- */}
          {(mascotType === 'fitbot' || mascotType === 'robot') && (
            <g className="mascot-fitbot">
              <line x1="100" y1="40" x2="100" y2="15" stroke="#7f8c8d" strokeWidth="4" />
              <circle cx="100" cy="10" r="6" fill={mood === 'pumped' ? '#ff0844' : '#00f2fe'} style={{ filter: 'url(#neonGlow)' }} />
              
              {/* Arms drawn behind body */}
              <g className="mascot-arm-left" style={{ transformOrigin: '55px 85px' }}>
                <path d="M 55 85 L 15 115 L 25 140" stroke="#7f8c8d" strokeWidth="12" strokeLinecap="square" strokeLinejoin="miter" fill="none" />
                {renderDumbbell(25, 140)}
              </g>
              <g className="mascot-arm-right" style={{ transformOrigin: '145px 85px' }}>
                <path d="M 145 85 L 185 115 L 175 140" stroke="#7f8c8d" strokeWidth="12" strokeLinecap="square" strokeLinejoin="miter" fill="none" />
                {renderDumbbell(175, 140)}
              </g>

              {/* Body */}
              <rect x="45" y="40" width="110" height="110" rx="15" fill="#2c3e50" className="mascot-body" />
              <rect x="55" y="55" width="90" height="60" rx="8" fill="#1a1a2e" />
              <rect x="55" y="55" width="90" height="60" rx="8" fill="url(#glassGrad)" style={{ opacity: 0.2 }} />
            </g>
          )}

          {/* --- KETTLEBELL --- */}
          {mascotType === 'kettlebell' && (
            <g className="mascot-kettlebell">
              {/* Handle (Shorter) */}
              <path d="M 85 90 L 75 65 C 70 50, 80 45, 100 45 C 120 45, 130 50, 125 65 L 115 90" stroke="#7f8c8d" strokeWidth="16" fill="none" strokeLinejoin="round" />
              <path d="M 85 90 L 75 65 C 70 50, 80 45, 100 45 C 120 45, 130 50, 125 65 L 115 90" stroke="#bdc3c7" strokeWidth="8" fill="none" strokeLinejoin="round" />
              
              {/* Body (Perfectly round sides, flat top/bottom via clip) */}
              <defs>
                <clipPath id="kbBodyClip">
                  <rect x="0" y="78" width="200" height="88" />
                </clipPath>
              </defs>
              <circle cx="100" cy="122" r="50" fill={mood === 'pumped' ? 'url(#pumpedGrad)' : '#2c3e50'} className="mascot-body" clipPath="url(#kbBodyClip)" />
              
              {/* Handle Highlights */}
              <path d="M 80 47 C 90 44, 110 44, 120 47" stroke="#bdc3c7" strokeWidth="4" fill="none" strokeLinecap="round" opacity="0.6" />
              
              {/* Highlights on body */}
              <path d="M 55 122 A 45 45 0 0 1 75 84" stroke="#ecf0f1" strokeWidth="6" fill="none" strokeLinecap="round" opacity="0.3" />
              <ellipse cx="75" cy="100" rx="12" ry="6" fill="#fff" opacity="0.3" transform="rotate(-25 75 100)" className="mascot-body" />
              
              {/* Blush */}
              <ellipse cx="75" cy="115" rx="8" ry="5" fill="#ff7675" opacity="0.6" />
              <ellipse cx="125" cy="115" rx="8" ry="5" fill="#ff7675" opacity="0.6" />

              {/* Tiny Cute Iron Arms */}
              <g className="mascot-arm-left" style={{ transformOrigin: '55px 125px' }}>
                <path d="M 55 125 L 35 135 L 25 150" stroke="#7f8c8d" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                {renderDumbbell(25, 150)}
              </g>
              <g className="mascot-arm-right" style={{ transformOrigin: '145px 125px' }}>
                <path d="M 145 125 L 165 135 L 175 150" stroke="#7f8c8d" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                {renderDumbbell(175, 150)}
              </g>
            </g>
          )}

          {/* COMMON EYES */}
          {!['cat', 'shiba', 'dog', 'fox', 'none'].includes(mascotType) && (
            <g className="mascot-eyes">
              {mood === 'happy' && (
                <>
                  <circle cx="80" cy={l.eyeY} r={l.eyeR} fill={l.eyeColor} style={['fitbot','robot'].includes(mascotType) ? {filter:'url(#neonGlow)'} : {}} />
                  <circle cx="120" cy={l.eyeY} r={l.eyeR} fill={l.eyeColor} style={['fitbot','robot'].includes(mascotType) ? {filter:'url(#neonGlow)'} : {}} />
                  <circle cx="82" cy={l.eyeY} r={l.pupilR} fill={l.pupilColor} />
                  <circle cx="122" cy={l.eyeY} r={l.pupilR} fill={l.pupilColor} />
                </>
              )}
              {mood === 'pumped' && (
                <>
                  <path d={`M 70 ${l.eyeY - 5} L 90 ${l.eyeY + 5} L 70 ${l.eyeY + 5} Z`} fill={['fitbot','robot'].includes(mascotType) ? '#ff0844' : l.eyeColor} style={['fitbot','robot'].includes(mascotType) ? {filter:'url(#neonGlow)'} : {}} />
                  <path d={`M 130 ${l.eyeY - 5} L 110 ${l.eyeY + 5} L 130 ${l.eyeY + 5} Z`} fill={['fitbot','robot'].includes(mascotType) ? '#ff0844' : l.eyeColor} style={['fitbot','robot'].includes(mascotType) ? {filter:'url(#neonGlow)'} : {}} />
                </>
              )}
            </g>
          )}

          {/* COMMON MOUTH */}
          {['blob', 'kettlebell'].includes(mascotType) && (
            <path d={mood === 'pumped' ? "M 90 125 Q 100 135, 110 125" : "M 90 120 Q 100 130, 110 120"} stroke="#fff" strokeWidth="4" strokeLinecap="round" fill="none" />
          )}
          {['panda'].includes(mascotType) && (
            <path d={mood === 'pumped' ? "M 90 110 Q 100 125, 110 110 Z" : "M 90 110 Q 95 115, 100 110 Q 105 115, 110 110"} fill={mood === 'pumped' ? "#ff7675" : "none"} stroke="#2f3640" strokeWidth="2.5" strokeLinecap="round" />
          )}
          {['fitbot', 'robot'].includes(mascotType) && (
            <path d={mood === 'pumped' ? "M 80 100 L 90 105 L 100 100 L 110 105 L 120 100" : "M 80 105 L 120 105"} stroke={mood === 'pumped' ? '#ff0844' : '#00f2fe'} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" style={{ filter: 'url(#neonGlow)' }} />
          )}

          {/* SWEAT */}
          {mood === 'pumped' && (
            <path d="M 140 50 Q 148 66, 140 74 Q 132 66, 140 50" fill="#3498db" className="mascot-sweat" />
          )}

          {/* RENDER ACCESSORY */}
          {renderAccessory()}

          </g>
        </g>
      </svg>
    </div>
  );
};

export default Mascot;
